var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef, memo } from "react";

var SvgPaymentCenter = function SvgPaymentCenter(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001223",
    stroke: "#3077b8",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "m47.969 1.25.5.422L49 3.156v43.719l-.281 1.094-.407.5-1.484.531H3.125l-1.11-.281-.5-.407L1 46.844V2.922l.766-1.438L3.156 1h43.735Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3077b8",
    strokeWidth: 4.863,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m5 31.831 3.285-5.611a.66.66 0 0 1 1.153.027l6.604 12.58a.66.66 0 0 0 1.18-.026l7.334-15.565a.66.66 0 0 1 1.16-.064L33.7 36.206a.66.66 0 0 0 1.185-.127L44 10"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPaymentCenter);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;